import _typeof from "/data/jenkins/workspaces/workspace/h5/node_modules/@babel/runtime/helpers/esm/typeof";

/* 说明：
1: JSON.stringfy --> set --> get --> JSON.parse
2: data format well return as set`s
3: undefined in array will be null after stringfy+parse
*/

/**
 * @desc legal data: "" [] {} null flase true
 * @desc illegal: undefined 1）key not se， 2）key is cleared， 3）key removed； 4）wrong data format
 * @param {*} key
 * @return {*}
 */
function get(key) {
  if (!key) {
    return undefined;
  }

  var val = localStorage.getItem(key) || sessionStorage.getItem(key);
  val = JSON.parse(val);

  if (val !== null) {
    // val format check
    return val.data;
  } // how to return illegal data for im？


  return undefined;
} // isPersistent


function set(key, val, isTemp) {
  var store = localStorage;

  if (isTemp) {
    store = sessionStorage;
  }

  var type = _typeof(val);

  store[key] = JSON.stringify({
    data: val,
    type: type
  });
}

function remove(key) {
  localStorage.removeItem(key);
  sessionStorage.removeItem(key);
}

export default {
  get: get,
  set: set,
  remove: remove
};